import { Injectable, inject } from '@angular/core';
import { IProductDataV3, Product } from '@df/catalog/product/product';
import { DfEventData, DfEventService } from '@df/core/service/df-event';
import { GtmDataService } from '@df/module-gtm/service/gtm-data.service';
import { GtmDlService } from '@df/module-gtm/service/gtm-dl.service';
import { TimeoutService } from '@df/ng/timeout.service';
import './gtm-event-view-item';

@Injectable({
    providedIn: 'root'
})
export class GtmEventViewItemTrigger {
    /**
     * GTM service
     */
    private gtmService = inject(GtmDlService);

    /**
     * DF events service
     */
    private dfEventService = inject(DfEventService);

    /**
     * GTM basket service
     */
    private gtmDataService = inject(GtmDataService);

    /**
     * Timeout service
     */
    private timeoutService = inject(TimeoutService);

    /**
     * Setup event listener
     */
    constructor() {
        this.init();
    }

    /**
     * Setup event listener
     */
    protected init() {
        const debounced = this.timeoutService.debounce(
            (trigger: DfEventData, model: Product<IProductDataV3>) => this.dispatch(trigger, model),
            1000
        );

        this.dfEventService.success(event => {
            if (event.id === 'dfViewModelChange' && event.data.model?.type === Product.type) {
                debounced(event, event.data.model! as Product<IProductDataV3>);
            }
        });
    }

    /**
     * Dispatch event
     */
    private async dispatch(trigger: DfEventData, product: Product<IProductDataV3>) {
        return this.gtmService.dispatch({
            event: 'view_item',
            triggerContext: {
                trigger,
                product
            },
            ecommerce: await this.gtmDataService.getEventData([{ product }])
        });
    }
}
